import { render } from "./MonetizationAd.vue?vue&type=template&id=2eb68a8c"
import script from "./MonetizationAd.vue?vue&type=script&lang=js"
export * from "./MonetizationAd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/ads/MonetizationAd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eb68a8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eb68a8c', __exports__)) {
    api.reload('2eb68a8c', __exports__)
  }
  
  module.hot.accept("./MonetizationAd.vue?vue&type=template&id=2eb68a8c", () => {
    api.rerender('2eb68a8c', render)
  })

}


export default __exports__